import { render, staticRenderFns } from "./TransactionView.vue?vue&type=template&id=763585da"
import script from "./TransactionView.vue?vue&type=script&lang=js"
export * from "./TransactionView.vue?vue&type=script&lang=js"
import style0 from "./TransactionView.vue?vue&type=style&index=0&id=763585da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports